import { Icon } from "@iconify/react";
import SessionContext from "components/session/SessionContext";
import { getTranslationContent } from "functions";
import LinkNext from "next/link";
import { useContext } from "react";
import useTranslation from "translations/hooks/useTranslation";
import Text from "./Text";

export default function ContactComponent({ data }) {
  const { t } = useTranslation();
  let {
    session: { lang },
  } = useContext(SessionContext);

  return (
    <div className="mb-5">
      <Text bold sectionTitle text={t("contactUs")} className={"my-5"} />
      <div className="grid grid-cols-1 md:grid-cols-2 grid-rows-4 gap-5 mb-5">
        <div className="col-span-1 row-span-4 ">
          <div className="bg-lightGrey p-5 rounded-button mb-5 flex flex-row items-center justify-start">
            <LinkContent
              href={`http://maps.apple.com/??ll=${data?.location?.coordinates[1]},${data?.location?.coordinates[0]}&q=@${data?.location?.coordinates[1]},${data?.location?.coordinates[0]}`}
            >
              <Icon
                icon={"carbon:location-filled"}
                className="w-6 h-6 md:w-8 md:h-8 text-black"
              />
              <div className="flex flex-col mx-4">
                <Text text={t("nakabaBuilding")} bold />
                <Text text={getTranslationContent(data, "address", lang)} />
              </div>
            </LinkContent>
          </div>
          <div className="bg-lightGrey p-5 rounded-button mb-5 flex flex-row items-center justify-start">
            <LinkContent href={`tel:${data?.phoneNumber}`}>
              <Icon
                icon={"fluent:call-24-filled"}
                className="w-6 h-6 md:w-8 md:h-8 text-black"
              />
              <div className="flex flex-col mx-4">
                <Text text={t("phoneNumber")} bold />
                <Text direction={"ltr"} text={data?.phoneNumber} />
              </div>
            </LinkContent>
          </div>
          <div className="bg-lightGrey p-5 rounded-button mb-5 flex flex-row items-center justify-start">
            <LinkContent href={`tel:${data?.whatsappNumber}`}>
              <Icon
                icon={"mingcute:whatsapp-fill"}
                className="w-6 h-6 md:w-8 md:h-8 text-black"
              />
              <div className="flex flex-col mx-4">
                <Text text={t("whatsAppNumber")} bold />
                <Text
                  direction={"rtl"}
                  text={data?.whatsappNumber ?? "... ... .."}
                />
              </div>
            </LinkContent>
          </div>
          <div className="bg-lightGrey p-5 rounded-button flex flex-row items-center justify-start">
            <LinkContent href={`mailto:${data?.email}`}>
              <Icon
                icon={"mdi:email"}
                className="w-6 h-6 md:w-8 md:h-8 text-black"
              />
              <div className="flex flex-col mx-4">
                <Text text={t("email")} bold />
                <Text direction={"ltr"} text={data?.email} />
              </div>
            </LinkContent>
          </div>
        </div>
        <div className="col-span-1 row-span-4">
          <div className="bg-lightGrey p-5 rounded-button h-full">
            <Text text={t("internalNumbers")} bold />
            <div
              className="mt-4 text-black"
              dangerouslySetInnerHTML={{
                __html: getTranslationContent(data, "description", lang),
              }}
            />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
        <div className="flex flex-col">
          <Text
            sectionTitle
            bold
            text={t("akkarBuilding")}
            className={"my-5"}
          />
          <div className="bg-lightGrey p-5 grid grid-rows-3 rounded-button">
            <div className="p-2 flex flex-row items-center justify-start">
              <LinkContent
                href={`http://maps.apple.com/??ll=${data?.location?.coordinates[1]},${data?.location?.coordinates[0]}&q=@${data?.location?.coordinates[1]},${data?.location?.coordinates[0]}`}
              >
                <Icon
                  icon={"carbon:location-filled"}
                  className="w-6 h-6 md:w-8 md:h-8 text-black"
                />
                <div className="flex flex-col mx-4">
                  <Text text={t("akkarBuilding")} bold />
                  <Text
                    text={getTranslationContent(data, "akkarAddress", lang)}
                  />
                </div>
              </LinkContent>
            </div>
            <div className="p-2 rounded-button flex flex-row items-center justify-start">
              <LinkContent href={`tel:${data?.akkarPhoneNumber}`}>
                <Icon
                  icon={"fluent:call-24-filled"}
                  className="w-6 h-6 md:w-8 md:h-8 text-black"
                />
                <div className="flex flex-col mx-4">
                  <Text text={t("phoneNumber")} bold />
                  <Text direction={"ltr"} text={data?.akkarPhoneNumber} />
                </div>
              </LinkContent>
            </div>
            <div className="p-2 rounded-button flex flex-row items-center justify-start">
              <LinkContent href={`mailto:${data?.akkarEmail}`}>
                <Icon
                  icon={"mdi:email"}
                  className="w-6 h-6 md:w-8 md:h-8 text-black"
                />
                <div className="flex flex-col mx-4">
                  <Text text={t("email")} bold />
                  <Text direction={"ltr"} text={data?.akkarEmail} />
                </div>
              </LinkContent>
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <Text sectionTitle bold text={t("lab")} className={"my-5"} />
          <div className="bg-lightGrey p-5 grid grid-rows-3  rounded-button">
            <div className="p-2 flex flex-row items-center justify-start">
              <LinkContent
                href={`http://maps.apple.com/??ll=${data?.location?.coordinates[1]},${data?.location?.coordinates[0]}&q=@${data?.location?.coordinates[1]},${data?.location?.coordinates[0]}`}
              >
                <Icon
                  icon={"carbon:location-filled"}
                  className="w-6 h-6 md:w-8 md:h-8 text-black"
                />
                <div className="flex flex-col mx-4">
                  <Text text={t("lab")} bold />
                  <Text
                    text={getTranslationContent(data, "labAddress", lang)}
                  />
                </div>
              </LinkContent>
            </div>
            <div className="p-2 rounded-button flex flex-row items-center justify-start">
              <LinkContent href={`tel:${data?.labPhoneNumber}`}>
                <Icon
                  icon={"fluent:call-24-filled"}
                  className="w-6 h-6 md:w-8 md:h-8 text-black"
                />
                <div className="flex flex-col mx-4">
                  <Text text={t("phoneNumber")} bold />
                  <Text direction={"ltr"} text={data?.labPhoneNumber} />
                </div>
              </LinkContent>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function LinkContent({ href, children }) {
  return (
    <>
      {children.map((child) => (
        <LinkNext href={href} key={`${Math.random() * 99}`}>
          <a target="_blank" style={{ cursor: "pointer", width: "auto" }}>
            {child}
          </a>
        </LinkNext>
      ))}
    </>
  );
}
